import React from "react";
import { Link } from "react-router-dom";

const Serviceprovider = () => {
  const rediningFeatures = [
    { title: "A Synced 9-Expert Medical Team", desc: "You don’t just get a gynecologist. You get 9 different specialists integrated and synced onto one single platform, ensuring your entire team is always on the exact same page.", img: "/Different1.png" },
    { title: "Proactive Daily Health Tracking", desc: "We don’t wait for your next monthly scan. Our AI-driven health tracker monitors your vitals daily to detect and prevent risks before they ever become complications.", img: "/Different2.png" },
    { title: "24/7 Access & End-to-End Management", desc: "Say goodbye to waiting rooms. Enjoy daily doctor engagement and instant midnight support, with your entire 9-month journey managed effortlessly on our innovative platform at your fingertips.", img: "/Different3.png" },
    { title: "Beyond Medical: True Holistic Care", desc: "We care for the woman, not just the womb. Enjoy built-in emotional health coaching, personalized nutrition, live prenatal yoga, and daily Garbhasanskar rituals.", img: "/Different4.png" },
    { title: "Convenient, Transparent & Affordable", desc: "Experience convenient, all-inclusive, celebratory pregnancy care at up to 40% less than the cost of a fragmented traditional system, with absolutely zero hidden costs.", img: "/Different5.png" },
  ];

  const differenceTools = [
    { title: "24/7 WhatsApp Expert Access", desc: "Skip the midnight Google searches. Text your pregnancy doubts directly to our certified gynecologists and get instant, reliable medical answers anytime.", img: "/Experience1.png", cta: "Chat With Expert" },
    { title: "Meet NurtureAI: Your Companion", desc: "Your 24/7 intelligent pregnancy guide. Our advanced AI analyzes your unique health profile to provide instant, personalized solutions and emotional support.", img: "/Experience2.png", cta: "Try NurtureAI" },
    { title: "Your Custom Pregnancy Blueprint", desc: "Wondering what your ideal care looks like? Answer a few quick questions, and our experts will craft a detailed, personalized 9-month roadmap just for you.", img: "/Experience3.png", cta: "Get My Blueprint" },
  ];

  return (
    <div className="service-provider-main">
    <section className="service-provider-edge-section" style={{ 
    backgroundImage: 'url("/DifferentB.png")', 
    backgroundSize: 'cover', 
    backgroundPosition: 'center',
    padding: '80px 0',
    position: 'relative'
  }}>
    <img src="/Beyondtop.png" className="top-edge" alt="" />
    <img src="/BeyondbottoM.png" className="bottom-edge" alt="" />
    <div className="container">
        <div className="text-center mb-5">
            <h2 className="journey-title">
                Not Just Different. Redefining <span className="pink-text">Pregnancy <br /> Care.</span>
            </h2>
            <p className="journey-subtitle mx-auto">
                The traditional clinic model relies on occasional checkups, leaving you to manage everything else alone. 
                We replaced that broken system with a proactive, tech-driven sanctuary. Here is why local clinics and hospitals 
                simply cannot match the Myprega experience.
            </p>
        </div>

        <div className="row align-items-end">
            <div className="col-lg-12">
                <div className="row g-4 mb-4">
                    {rediningFeatures.slice(0, 3).map((feat, i) => (
                        <div key={i} className="col-md-4">
                            <div className="service-feature-card service-feature-card-primary">
                                <img src={feat.img} alt="" className="service-feature-icon" />
                                <h5 className="service-feature-title">{feat.title}</h5>
                                <p className="service-feature-desc">{feat.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="row g-4 align-items-center">
                    <div className="col-md-4">
                        <div className="service-feature-card service-feature-card-primary">
                            <img src={rediningFeatures[3].img} alt="" className="service-feature-icon" />
                            <h5 className="service-feature-title">{rediningFeatures[3].title}</h5>
                            <p className="service-feature-desc">{rediningFeatures[3].desc}</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="service-feature-card service-feature-card-primary">
                            <img src={rediningFeatures[4].img} alt="" className="service-feature-icon" />
                            <h5 className="service-feature-title">{rediningFeatures[4].title}</h5>
                            <p className="service-feature-desc">{rediningFeatures[4].desc}</p>
                        </div>
                    </div>
                    <div className="col-md-4 text-center">
                        <img src="/DifferentS.png" alt="Care" className="img-fluid service-provider-hero-image" />
                    </div>
                </div>
            </div>
        </div>
        <div className="text-center mt-5">
            <p className="service-provider-note">
                MyPrega is not an app.<br />
                <span>It’s a companion for motherhood.</span>
            </p>
        </div>
    </div>
</section>

      <section className="service-provider-tools-section" style={{ padding: '80px 0', background: '#fff' }}>
        <div className="container">
          <div className="text-center mb-5">
           <h2 className="journey-title">
              Experience the <span className="pink-text">Myprega</span> Difference, <br /> On Us.
            </h2>
            <p className="journey-subtitle mx-auto">
              Not ready to choose your complete care package just yet? We understand. Take
              your first step toward a stress-free pregnancy by exploring our expert-backed tools. Get instant
              clarity, personalized guidance, and absolute peace of mind today—completely free.
            </p>
          </div>

          <div className="row g-4">
            {differenceTools.map((tool, i) => (
              <div key={i} className="col-md-4">
                <div style={{ 
                  background: '#F9F9F9', 
                  borderRadius: '25px', 
                  overflow: 'hidden', 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: '0.3s'
                }} className="hover-card">
                  <img src={tool.img} alt="" className="w-100" style={{ height: '328px', objectFit: 'cover' }} />
                  <div style={{ padding: '25px', display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <h5 style={{ fontFamily: 'Nunito, sans-serif', fontWeight: '600', fontSize: '22px', lineHeight: '100%', letterSpacing: '0%', paddingBottom: "10px" , }}>{tool.title}</h5>
                    <p style={{ fontFamily: 'Nunito, sans-serif', fontWeight: '400', fontSize: '18px', lineHeight: '24px', letterSpacing: '0%',  }}>{tool.desc}</p>
                    {tool.title === "Meet NurtureAI: Your Companion" ? (
                      <button
                        className="service-provider-tool-btn"
                        onClick={() => {
                          window.location.href = "/AIDashboardV3";
                        }}
                      >
                        {tool.cta}
                      </button>
                    ) : tool.title === "24/7 WhatsApp Expert Access" ? (
                      <button
                        className="service-provider-tool-btn"
                        onClick={() => {
                          window.open("https://wa.me/919702324628", "_blank");
                        }}
                      >
                        {tool.cta}
                      </button>
                    ) : tool.title === "Your Custom Pregnancy Blueprint" ? (
                      <button
                        className="service-provider-tool-btn"
                        onClick={() => {
                          window.location.href = "/form";
                        }}
                      >
                        {tool.cta}
                      </button>
                    ) : (
                      <button className="service-provider-tool-btn">
                        {tool.cta}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Serviceprovider;
